export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=704acd80f3eedcdb3a165c173db72c572c14076b39&name=pushAdClickData!'